export default __webpack_public_path__ + "static/mean-cycle-1-d-90d31fb2ea6718a84d67a642611cd6e4.svg";